<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import LaisCard from 'dashboard/components-next/LaisCard.vue';

defineProps({
  darkModeEnabled: { type: Boolean, default: false },
});

const emit = defineEmits(['toggleDarkMode']);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Aparência do dashboard">
    <p class="text-[13px] leading-6 text-lais-text-muted mb-3">
      Você pode optar por usar o dashboard em modo escuro. A preferência é salva
      neste navegador e pode ser desativada a qualquer momento.
    </p>
    <div
      class="flex items-center justify-between rounded-lais border border-lais-border bg-white px-4 py-3"
    >
      <div>
        <p class="text-[14px] font-semibold text-lais-text">Modo escuro</p>
        <p class="text-[12px] text-lais-text-muted">
          Reduz brilho em ambientes pouco iluminados.
        </p>
      </div>
      <button
        type="button"
        role="switch"
        :aria-checked="darkModeEnabled"
        class="relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors"
        :class="darkModeEnabled ? 'bg-lais-primary' : 'bg-[#cbd5e1]'"
        @click="emit('toggleDarkMode')"
      >
        <span
          class="inline-block size-4 transform rounded-full bg-white transition-transform"
          :class="darkModeEnabled ? 'translate-x-6' : 'translate-x-1'"
        />
      </button>
    </div>
  </LaisCard>
</template>
